import { orchestrator } from '../clients.ts'
import { ApiError } from '../errors.ts'
import { endSession } from './authApi.ts'

/**
 * 로그아웃 — `POST /auth/logout`(Bearer 필요). 서버가 세션을 즉시 폐기한다(UAM-SES-03).
 *
 * ⚠ **파일을 따로 둔 이유**: `clients.ts` 가 갱신 함수(`refreshSession`)를 쓰고, 갱신은
 *   `authApi.ts` 에 있다. 로그아웃까지 거기 두면 `authApi ↔ clients` 순환이 생겨
 *   번들러가 청크를 못 가른다. 방향을 한쪽으로만 흐르게 갈라 둔다.
 *
 * 🔴 실패해도 **로컬 정리는 반드시 한다.** 이미 죽은 세션이면 401 이 오는데,
 *    그때 자격을 남겨 두면 다음 요청이 또 401 을 맞는다.
 */
export async function logout(): Promise<void> {
  try {
    await orchestrator.request<void>({ method: 'POST', path: '/auth/logout' })
  } catch (error) {
    if (!(error instanceof ApiError)) throw error
  } finally {
    // 🔴 사람이 «직접» 끝낸 것이다 — 로그인 화면의 문구가 만료와 달라진다
    endSession('logout')
  }
}
